/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-29 15:02:29
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 14:11:35
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Currency/index.tsx
 */

import { SectionWrapper } from '@/src/components';
import { Button, Select } from '@/src/components/Antd';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { getCurrencies } from '@/src/constrains/GlobalProvider/slice';
import GoBackAndBreadCrumb from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRightBtnsGroups from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { Icon } from '@/src/tools/icon';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Popover, Table } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import SplitLine from 'src/components/SplitLine/SplitLine';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';

import { CurrencyModal } from './Components';
import { breadcrumbData } from './config';
import useService from './service';
import useModalService from './service/modal.service';
import styles from './style.module.less';
import { Form } from '@/src/components/Antd';
import CurrencyFormat from './CurrencyFormat';
import { get } from 'lodash';
import { WarningModal } from '@/src/components/Antd';
import { modal } from '@/src/utils/Modal';
// import { get } from 'lodash';
// import { conversionOptions } from './constant';

const permissions = () => {
  const view_currency_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsCurrency,
        operation: EnumOperation.view_currency_setting,
      }),
    ],
  });
  const edit_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsCurrency,
        operation: EnumOperation.edit_setting,
      }),
    ],
  });
  return {
    view_currency_setting,
    edit_setting,
  };
};

function Currency() {
  const { view_currency_setting, edit_setting } = permissions();
  const {
    navigateBack,
    handleSubmit,
    handleDiscard,
    handleEditList,
    handleCleanAfterClose,
    // handleDeleteCurrency,
    handleEditCurrency,
    handleCurrencyFormatChange,
    currencyError,
    currencyFormat,
    editingCurrency,
    currencyList,
    languages,
    saveDisabled,
    form,
    getI18n,
    handleOnFormValuesChange,
    selectedRecord,
    deleteVisible,
    handleOnCurrencyDelete,
    handleOnCurrencyModalClose,
    handleOnCurrencyModalOpen,
  } = useService();
  const { visible, setVisible } = useModalService();

  const currencies = useSelector(getCurrencies());

  const reportingCurrencies = currencies?.filter((c) => c.reportingCurrency)[0];

  const columns = [
    {
      title: getI18n('storeCurrency.detail.currency'),
      dataIndex: 'currencyName',
    },
    {
      title: getI18n('storeCurrency.detail.conversionRate'),
      dataIndex: 'rate',
      render: (text, record) => {
        const fixedRate = get(record, 'fixedRate');
        return (
          <>
            <div>{fixedRate ? record.rate : record.realTimeRate}</div>
            {!record.fixedRate &&
              (record.maxRateChecked || record.minRateChecked) && (
                <div>{`(${
                  record.maxRateChecked ? `Max:${record.maxRate}` : ''
                } ${
                  record.minRateChecked ? `Min:${record.minRate}` : ''
                })`}</div>
              )}
          </>
        );
      },
    },
    {
      title: getI18n('storeCurrency.detail.rateType'),
      dataIndex: 'fixedRate',
      render: (text) =>
        text
          ? getI18n('storeCurrency.detail.fixedRate')
          : getI18n('storeCurrency.detail.realTimeRate'),
    },
    {
      title: getI18n('general.sider.salesChannel'),
      dataIndex: 'salesChannels',
      render: (text) => {
        if (Array.isArray(text)) {
          return (
            <>
              {text.length === 0 ? (
                getI18n('storeCurrency.detail.notAssign')
              ) : (
                <div className={styles.salesChannel}>
                  {text.map((t) => {
                    return (
                      <div key={t.salesChannelUuid}>
                        <div className={styles.name}>{t.salesChannelName}</div>
                        <div className={styles.type}>{t.channelType}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          );
        } else {
          return getI18n('storeCurrency.detail.notAssign');
        }
      },
    },
    !edit_setting
      ? {}
      : {
          title: getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
          render: (text, record) => {
            const salesChannels = get(record, 'salesChannels') || [];
            const isApplied = salesChannels.length > 0;
            return (
              <div className={styles.actions}>
                <span
                  className={styles.delete}
                  onClick={() => {
                    if (!isApplied) {
                      handleOnCurrencyModalOpen(record);
                    } else {
                      modal.error({
                        title: getI18n(
                          'storeCurrency.detail.unabletoDeletecurrency',
                        ),
                        content: getI18n('storeCurrency.detail.tip1'),
                        onOk: () => {
                          return;
                        },
                        onOkText: getI18n('general.antd.Uploader.ok'),
                      });
                    }
                  }}>
                  {getI18n('general.delete')}
                </span>
                <span
                  className={styles.edit}
                  onClick={() => {
                    setVisible(true);
                    handleEditCurrency(record);
                  }}>
                  {getI18n('general.edit')}
                </span>
              </div>
            );
          },
        },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <GoBackAndBreadCrumb
          goBack={navigateBack}
          breadcrumbData={breadcrumbData({ getI18n })}
        />
        <TopRightBtnsGroups
          onSubmit={handleSubmit}
          onDiscard={handleDiscard}
          onSaveDisable={saveDisabled}
        />
      </div>
      <Form form={form} onValuesChange={handleOnFormValuesChange}>
        <div className={styles.content}>
          <SectionWrapper
            className={styles.wrapper}
            title={
              <div className={styles.title}>
                <span>{getI18n('storeCurrency.detail.reportingCurrency')}</span>
                <Popover
                  title={null}
                  content={<Hint1 getI18n={getI18n} />}
                  placement='right'>
                  <Icon type='icontooltip' className={styles.icon} />
                </Popover>
              </div>
            }>
            <div className={styles.reportingCurrency}>
              {getI18n('storeCurrency.detail.reportingCurrency')}
            </div>
            <div className={styles.label}>{reportingCurrencies?.label}</div>
            <SplitLine className={styles.splitLine} />
            <ItemWrapper
              containerClassName={styles.regionalCurrencyFormat}
              title={
                getI18n('storeCurrency.detail.regionalCurrencyFormat') + '*'
              }>
              {view_currency_setting && (
                <Select
                  size='large'
                  error={currencyError}
                  help='Regional Currency Format Is Required'
                  optionsList={languages}
                  value={currencyFormat}
                  onChange={handleCurrencyFormatChange}
                  disabled={!edit_setting}
                />
              )}
            </ItemWrapper>
          </SectionWrapper>
          <SectionWrapper
            className={styles.wrapper}
            title={
              <div className={styles.title}>
                <span>
                  {getI18n('storeCurrency.detail.otherAvailableCurrency')}
                </span>
                <Popover
                  title={null}
                  content={<Hint2 getI18n={getI18n} />}
                  placement='right'>
                  <Icon type='icontooltip' className={styles.icon} />
                </Popover>
              </div>
            }>
            {currencyList.length === 0 && view_currency_setting && (
              <span>{getI18n('storeCurrency.detail.notAssign')}</span>
            )}
            {currencyList.length !== 0 && view_currency_setting && (
              <Table
                pagination={false}
                rowKey={'currencyCode'}
                bordered
                columns={columns}
                dataSource={currencyList}
              />
            )}
            <div className={styles.add_wrapper}>
              <Button
                type='primary'
                onClick={() => setVisible(true)}
                disabled={!edit_setting}>
                {getI18n('storeCurrency.detail.addCurrency')}
              </Button>
            </div>
          </SectionWrapper>
          <CurrencyFormat />
        </div>
      </Form>
      <CurrencyModal
        editingCurrency={editingCurrency}
        currencyList={currencyList}
        visible={visible}
        afterClose={handleCleanAfterClose}
        onCancel={() => setVisible(false)}
        onSubmit={handleEditList}
      />
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.commonHeader.discard_text')}
        active={!saveDisabled}
        title={getI18n('general.commonHeader.discard_header')}
        content={getI18n('general.commonHeader.leave_content')}
      />

      <div id='currency-warning-modal'>
        {selectedRecord && (
          <WarningModal
            visible={deleteVisible}
            header={
              Array.isArray(selectedRecord.salesChannels) &&
              selectedRecord.salesChannels.length !== 0
                ? getI18n('storeCurrency.detail.unabletoDeletecurrency')
                : getI18n('storeCurrency.detail.deletecurrency')
            }
            okText={
              Array.isArray(selectedRecord.salesChannels) &&
              selectedRecord.salesChannels.length !== 0
                ? getI18n('general.antd.Uploader.ok')
                : getI18n('general.delete')
            }
            onOk={() => {
              handleOnCurrencyDelete();
              //handleOnCurrencyModalClose();
            }}
            onCancel={handleOnCurrencyModalClose}>
            {Array.isArray(selectedRecord.salesChannels) &&
            selectedRecord.salesChannels.length !== 0
              ? getI18n('storeCurrency.detail.tip1')
              : getI18n('storeCurrency.detail.tip2')}
          </WarningModal>
        )}
      </div>
    </div>
  );
}

export default Currency;

const Hint1 = ({ getI18n }) => (
  <div className={styles.hint}>
    <div className={styles.hintTitle}>
      {getI18n('storeCurrency.detail.reportingCurrency')}
    </div>
    <p className={styles.paragraph}>
      {getI18n('storeCurrency.detail.reportingCurrencyHint1Text1')}
    </p>
    <p className={styles.paragraph}>
      {getI18n('storeCurrency.detail.reportingCurrencyHint1Text2')}
    </p>
  </div>
);

const Hint2 = ({ getI18n }) => (
  <div className={styles.hint}>
    <div className={styles.hintTitle}>
      {getI18n('storeCurrency.detail.otherAvailableCurrency')}
    </div>
    <p className={styles.paragraph}>
      {getI18n('storeCurrency.detail.reportingCurrencyHint2Text1')}
    </p>
    <p className={styles.paragraph}>
      {getI18n('storeCurrency.detail.reportingCurrencyHint2Text2')}
    </p>
  </div>
);
